<template>
	<div class="datepicker"
			 :class="{'datepicker-range':range,'datepicker__clearable':clearable&&text&&!disabled}">
		<input v-if="type!=='inline'" readonly
		 :value="text"
		 :class="[show ? 'focus' : '', inputClass, 'bdtime']"
		 :disabled="disabled"
		 :placeholder="placeholder"
		 :name="name"
		 />
		<a class="datepicker-close" @click.stop="cls"></a>
		<transition name="datepicker-anim">
			<div class="datepicker-popup bdSub"
					 :class="[popupClass,{'datepicker-inline':type==='inline'}]"
					 tabindex="-1"
					 v-if="show||type==='inline'">
				<template v-if="range">
					<vue-datepicker-local-calendar v-model="dates[0]"
					 :clicktitle='clicktitle'
					 @RangeDayEnd='rangeDayEnd'
					 :rangeDay="rangeDay"
					 :area="area"
					 :left="true"></vue-datepicker-local-calendar>
					<vue-datepicker-local-calendar v-model="dates[1]"
					 :clicktitle='clicktitle'
					 :rangeDay="rangeDay"
					 :area="area"
					 :right="true"></vue-datepicker-local-calendar>
				</template>
				<template v-else-if="type=='week'">
					<vue-datepicker-local-calendar v-model="dates[0]" :area="area"
					 :weekregion="weekregion"></vue-datepicker-local-calendar>
				</template>
				<template v-else>
					<vue-datepicker-local-calendar v-model="dates[0]"
					 :highlight="highlight"
					 :area="area"
					 :type="type"></vue-datepicker-local-calendar>
				</template>
				<div v-if="showButtons"
						 class="datepicker__buttons">
					<button @click.prevent.stop="cancel" class="datepicker__button-cancel">{{this.local.cancelTip}}</button>
					<button @click.prevent.stop="submit" class="datepicker__button-select">{{this.local.submitTip}}</button>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import VueDatepickerLocalCalendar from './VueDatepickerLocalCalendar.vue'

function getTextOption () {
	let option = {};
	switch (stage.languageId) {
		case "zh":
			option = {
				dow: 1, // Monday is the first day of the week
				hourTip: '选择小时', // tip of select hour
				minuteTip: '选择分钟', // tip of select minute
				secondTip: '选择秒数', // tip of select second
				yearSuffix: '年', // format of head
				monthsHead: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'), // months of head
				months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'), // months of panel
				weeks: '一_二_三_四_五_六_日'.split('_'), // weeks
				cancelTip: '取消', // default text for cancel button
				submitTip: '确定' // default text for submit button
			};
			break;
		default:
			option = {
				dow: 0, // Sunday is the first day of the week
				hourTip: 'Select Hour', // tip of select hour
				minuteTip: 'Select Minute', // tip of select minute
				secondTip: 'Select Second', // tip of select second
				yearSuffix: '', // suffix of head year
				monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), // months of head
				months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), // months of panel
				weeks: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), // weeks,
				cancelTip: 'cancel',
				submitTip: 'confirm',
			};
			break;
	}
	return option;
}

export default {
	name: 'VueDatepickerLocal',
	components: { VueDatepickerLocalCalendar },
	props: {
		name: [String],
		inputClass: [String],
		popupClass: [String],
		value: [Date, Array, String],
		disabled: [Boolean],
		type: {
			type: String,
			default: 'normal'
		},
		rangeDay: {
			type: Number,
			default: -1
		},
		rangeSeparator: {
			type: String,
			default: '~'
		},
		clearable: {
			type: Boolean,
			default: false
		},
		placeholder: [String],
		disabledDate: {
			type: Function,
			default: () => {
				return false
			}
		},
		format: {
			type: String,
			default: 'YYYY/MM/DD'
		},
		local: {
			type: Object,
			default: () => (getTextOption())
		},
		showButtons: {
			type: Boolean,
			default: false
		},
		dateRangeSelect: [Function],
		highlight: {
			type: Array,
			default: () => ([])
		},
		clicktitle: {
			type: Boolean,
			default: true
		},
		area:{//可选的时间范围
			type:Array,
			default:null
		}
	},
	data () {
		return {
			show: false,
			dates: this.vi(this.value),
			weekregion: []
		}
	},
	computed: {
		range () {
			return this.dates.length === 2
		},
		text () {
			const val = this.value
			const txt = this.dates.map(date => this.tf(date)).join(` ${this.rangeSeparator} `);
			if (this.type == 'week') {
				const txt = this.weekregion.map(date => this.tf(new Date(date))).join(` ${this.rangeSeparator} `);
				return txt;
			}
			if (Array.isArray(val)) {
				return val.length > 1 ? txt : ''
			} else {
				return val ? txt : ''
			}
		}
	},
	watch: {
		value (val) {
			if (this.type == 'week') {
				this.weekregion = [];
				let presentDate = val,
					weekday = presentDate.getDay() || 7;;
				let fd = presentDate.setDate(presentDate.getDate() - weekday + 1);
				this.weekregion.push(this.tf(new Date(fd)));//本周第一天
				this.weekregion.push(this.tf(new Date((fd / 1000 + 6 * 86400) * 1000)));//本周最后一天
			}
			this.dates = this.vi(this.value);
		}
	},
	methods: {
		get () {
			let returnA = Array.isArray(this.value) ? this.dates : this.dates[0];
			return returnA;
		},
		getWeekRegion () {
			let returnA = Array.isArray(this.value) ? this.dates : this.dates[0];
			if (this.type == 'week') {
				returnA = this.weekregion;
			}
			return returnA;
		},
		cls () {
			this.$emit('input', this.range ? [] : '')
		},
		vi (val) {
			if (Array.isArray(val)) {
				return val.length > 1 ? val.map(item => new Date(item)) : [new Date(), new Date()]
			} else {
				return val ? new Array(new Date(val)) : [new Date()]
			}
		},
		rangeDayEnd (v) {
			setTimeout(() => {
			let [start, end] = this.get()
			let starts = new Date(start)
			end = new Date(starts.setDate(start.getDate() + v))
			this.$emit('input', [start, end])
			}, 100);
		
			// this.$emit('RangeDayEnd', v)
		},
		ok (leaveOpened) {
			const $this = this
			$this.$emit('input', $this.get())
			//   !leaveOpened && !$this.showButtons && setTimeout(() => {
			// 	$this.show = $this.range
			//   })
			$this.show = false
		},
		selectOk (val) {
			// console.log(val);
			const $this = this
			$this.$emit('input', val)
		},
		tf (time, format) {
			const year = time.getFullYear()
			const month = time.getMonth()
			const day = time.getDate()
			const hours24 = time.getHours()
			const hours = hours24 % 12 === 0 ? 12 : hours24 % 12
			const minutes = time.getMinutes()
			const seconds = time.getSeconds()
			const milliseconds = time.getMilliseconds()
			const dd = t => ('0' + t).slice(-2)
			const map = {
				YYYY: year,
				MM: dd(month + 1),
				MMM: this.local.months[month],
				MMMM: this.local.monthsHead[month],
				M: month + 1,
				DD: dd(day),
				D: day,
				HH: dd(hours24),
				H: hours24,
				hh: dd(hours),
				h: hours,
				mm: dd(minutes),
				m: minutes,
				ss: dd(seconds),
				s: seconds,
				S: milliseconds
			}
			return (format || this.format).replace(/Y+|M+|D+|H+|h+|m+|s+|S+/g, str => map[str])
		},
		dc (e) {
			this.show = this.$el.contains(e.target) && !this.disabled
			if (this.show) {
				this.$nextTick(() => {
					let $drop = $(this.$el).find(".datepicker-popup");
					if ($drop.offset().left + $drop.innerWidth() > $(window).width()) {
						$drop.css({ right: 0 });
					}
				});
			}
		},
		submit () {
			this.$emit('confirm', this.get())
			this.show = false
		},
		cancel () {
			this.$emit('cancel', this.get())
			this.show = false
		}
	},
	mounted () {
		document.addEventListener('click', this.dc, true);
		if (this.type == 'week') {
			this.weekregion = [];
			let presentDate = new Date(),
				today = presentDate.getDay();
			let fd = new Date(presentDate.getTime() - (today - 1) * 86400000);
			this.weekregion.push(this.tf(fd));//本周第一天
			this.weekregion.push(this.tf(new Date((fd / 1000 + 6 * 86400) * 1000)));//本周最后一天
		}
	},
	beforeDestroy () {
		document.removeEventListener('click', this.dc, true)
	}
}
</script>

<style lang="scss" scoped>
//@import "~@/style/definition.scss";
.datepicker {
	width: 208px;
	display: inline-block;
	position: relative;
}
.datepicker:before {
	content: "";
	display: block;
	position: absolute;
	width: 34px;
	height: 100%;
	top: 0;
	right: 0;
	background: url("data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPjxwYXRoIGQ9Ik01NjQgMTgwLjJINDQ4Yy04LjMgMC0xNS02LjctMTUtMTVzNi43LTE1IDE1LTE1aDExNmM4LjIgMCAxNSA2LjcgMTUgMTVzLTYuOCAxNS0xNSAxNXoiIGZpbGw9IiM5ODk4OTgiLz48cGF0aCBkPSJNOTQ1IDk1Mi4ySDgxLjJjLTguMiAwLTE1LTYuNy0xNS0xNVYxNjIuOGMwLTguMyA2LjgtMTUgMTUtMTVIMjk0YzguMiAwIDE1IDYuNyAxNSAxNXMtNi44IDE1LTE1IDE1SDk2LjJ2NzQ0LjRIOTMwVjE3Ny44SDcxMy42Yy04LjMgMC0xNS02LjctMTUtMTVzNi43LTE1IDE1LTE1SDk0NWM4LjIgMCAxNSA2LjcgMTUgMTV2Nzc0LjRjMCA4LjMtNi44IDE1LTE1IDE1eiIgZmlsbD0iIzk4OTg5OCIvPjxwYXRoIGQ9Ik0zMzMuMyA1NTFIMjE2Yy04LjIgMC0xNS02LjgtMTUtMTVzNi44LTE1IDE1LTE1aDExNy4zYzguMyAwIDE1IDYuNiAxNSAxNXMtNi43IDE1LTE1IDE1em0yMzAuMyAwSDQ0Ni4zYy04LjMgMC0xNS02LjgtMTUtMTVzNi43LTE1IDE1LTE1aDExNy4zYzguMiAwIDE1IDYuNiAxNSAxNXMtNi44IDE1LTE1IDE1em0yMzAuMiAwSDY3Ni42Yy04LjMgMC0xNS02LjgtMTUtMTVzNi43LTE1IDE1LTE1aDExNy4yYzguMyAwIDE1IDYuNiAxNSAxNXMtNi43IDE1LTE1IDE1ek0zMzMuMyA3NDBIMjE2Yy04LjIgMC0xNS02LjgtMTUtMTVzNi44LTE1IDE1LTE1aDExNy4zYzguMyAwIDE1IDYuNiAxNSAxNXMtNi43IDE1LTE1IDE1em0yMzAuMyAwSDQ0Ni4zYy04LjMgMC0xNS02LjgtMTUtMTVzNi43LTE1IDE1LTE1aDExNy4zYzguMiAwIDE1IDYuNiAxNSAxNXMtNi44IDE1LTE1IDE1em0yMzAuMiAwSDY3Ni42Yy04LjMgMC0xNS02LjgtMTUtMTVzNi43LTE1IDE1LTE1aDExNy4yYzguMyAwIDE1IDYuNiAxNSAxNXMtNi43IDE1LTE1IDE1ek0zNzAuOCAyNTguNmMtOC4zIDAtMTUtNi43LTE1LTE1Vjg2LjhjMC04LjIgNi43LTE1IDE1LTE1czE1IDYuOCAxNSAxNXYxNTYuOGMwIDguMy02LjcgMTUtMTUgMTV6bTI3MC4yIDBjLTguMyAwLTE1LTYuNy0xNS0xNVY4Ni44YzAtOC4yIDYuNy0xNSAxNS0xNXMxNSA2LjggMTUgMTV2MTU2LjhjMCA4LjMtNi43IDE1LTE1IDE1ek05NDUgMzcyLjJIODEuMmMtOC4yIDAtMTUtNi43LTE1LTE1czYuOC0xNSAxNS0xNUg5NDVjOC4yIDAgMTUgNi43IDE1IDE1cy02LjggMTUtMTUgMTV6IiBmaWxsPSIjOTg5ODk4Ii8+PC9zdmc+")
		no-repeat 50% 50%;
}
.datepicker-close {
	display: none;
	position: absolute;
	width: 34px;
	height: 100%;
	top: 0;
	right: 0;
	cursor: pointer;
}
.datepicker-close:before {
	display: block;
	content: "";
	position: absolute;
	width: 16px;
	height: 16px;
	left: 50%;
	top: 50%;
	margin-left: -8px;
	margin-top: -8px;
	text-align: center;
	background: #ccc;
	color: #fff;
	border-radius: 50%;
	background: #ccc
		url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDciIHdpZHRoPSI3IiBoZWlnaHQ9IjciPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik01LjU4LDVsMi44LTIuODFBLjQxLjQxLDAsMSwwLDcuOCwxLjZMNSw0LjQxLDIuMiwxLjZhLjQxLjQxLDAsMCwwLS41OC41OGgwTDQuNDIsNSwxLjYyLDcuOGEuNDEuNDEsMCwwLDAsLjU4LjU4TDUsNS41OCw3LjgsOC4zOWEuNDEuNDEsMCwwLDAsLjU4LS41OGgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNSAtMS40OCkiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4NCg==")
		no-repeat 50% 50%;
}
.datepicker__clearable:hover:before {
	display: none;
}
.datepicker__clearable:hover .datepicker-close {
	display: block;
}
.datepicker-close:hover:before {
	background-color: #afafaf;
}
.datepicker > input {
	color: #666;
	transition: all 200ms ease;
	border: 1px solid #e5e5e5;
	height: 30px;
	box-sizing: border-box;
	outline: none;
	padding: 0 34px 0 12px;
	font-size: 12px;
	border-radius: 2px;
	width: 100%;
	user-select: none;
	-ms-user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
}
.datepicker > input.focus {
	border-color: $mainColor;
	//   -webkit-box-shadow: 0 0 5px rgba(59, 180, 242, .3);
	//   box-shadow: 0 0 5px rgba(59, 180, 242, .3);
}
.datepicker > input:disabled {
	cursor: not-allowed;
	background-color: #ebebe4;
	border-color: #e5e5e5;
	-webkit-box-shadow: none;
	box-shadow: none;
}
.datepicker-popup {
	position: absolute;
	//   bottom:30px;
	transition: all 200ms ease;
	opacity: 1;
	transform: scaleY(1);
	transform-origin: center top;
	font-size: 12px;
	background: #fff;
	box-shadow: 0 0.5em 2em rgba($black, 0.2);
	margin-top: 2px;
	outline: 0;
	padding: 5px;
	overflow: hidden;
	z-index: 999;
}
.datepicker-inline {
	position: relative;
	margin-top: 0;
}
.datepicker-range {
	//   min-width: 325px
}
.datepicker-range .datepicker-popup {
	//   width: 403px;
	width: 416px;
}
.datepicker-bottom {
	float: left;
	width: 100%;
	text-align: right;
}
.datepicker-btn {
	padding: 5px 10px;
	background: #1284e7;
	color: #fff;
	border-radius: 4px;
	display: inline-block;
	cursor: pointer;
}
.datepicker-anim-enter-active {
	transform-origin: 0 0;
	animation: datepicker-anim-in 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.datepicker-anim-leave-active {
	transform-origin: 0 0;
	animation: datepicker-anim-out 0.2s cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.datepicker__buttons {
	display: block;
	text-align: right;
}
.datepicker__buttons button {
	display: inline-block;
	font-size: 13px;
	border: none;
	cursor: pointer;
	margin: 10px 0 0 5px;
	padding: 5px 15px;
	color: #ffffff;
}
.datepicker__buttons .datepicker__button-select {
	background: #1284e7;
}
.datepicker__buttons .datepicker__button-cancel {
	background: #666;
}
@keyframes datepicker-anim-in {
	0% {
		opacity: 0;
		transform: scaleY(0.8);
	}
	to {
		opacity: 1;
		transform: scaleY(1);
	}
}
@keyframes datepicker-anim-out {
	0% {
		opacity: 1;
		transform: scaleY(1);
	}
	to {
		opacity: 0;
		transform: scaleY(0.8);
	}
}
</style>



// WEBPACK FOOTER //
// src/plugins/datePicker/VueDatepickerLocal.vue